/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { ScreenTaskControllerTypes } from '../../../core/navigation';
import {
    onKeyBackNoNetworkOverlay,
    onKeyOkNoNetworkOverlay,
} from '../../overlay/nonetworkoverlay/nonetworkoverlay.reducers';
import { showManageScreen } from '../../screens/screens.reducers';

export const onKeyBackEmptyToDoList = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.NO_TASK:
            dispatch(showManageScreen());
            return;

        case ScreenTaskControllerTypes.NO_NETWORK_OVERLAY:
            dispatch(onKeyBackNoNetworkOverlay());
            break;

        default:
    }
};

export const onKeyOkEmptyToDoList = () => (dispatch: Function, getState: Function) => {
    const { screenTaskController } = getState().screens;

    switch (screenTaskController) {
        case ScreenTaskControllerTypes.NO_NETWORK_OVERLAY:
            dispatch(onKeyOkNoNetworkOverlay());
            break;

        default:
    }
};
